export default {
  UPCOMING_MATCH_LIST: 30,
  LIVE_MATCH_LIST: 30,
  COMPLETED_MATCH_LIST: 30,
  TRANSACTION_LIST: 25,
  GAME_TRANSACTION_LIST: 10,
  LEADERBOARD_LIST: 50,
  EARNING_TRANSACTION_LIST: 25,
  MY_CONTEST_LIST: 30
};
